function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#F0F0F0"
}), React.createElement("path", {
  d: "M7.65283 7.99992H16.0006C16.0006 7.27783 15.9044 6.5784 15.7251 5.91296H7.65283V7.99992Z",
  fill: "#D80027"
}), React.createElement("path", {
  d: "M7.65283 3.8261H14.8265C14.3367 3.02698 13.7106 2.32064 12.9806 1.73914H7.65283V3.8261Z",
  fill: "#D80027"
}), React.createElement("path", {
  d: "M7.99993 16.0001C9.88271 16.0001 11.6132 15.3494 12.9798 14.261H3.02002C4.38661 15.3494 6.11714 16.0001 7.99993 16.0001Z",
  fill: "#D80027"
}), React.createElement("path", {
  d: "M1.17447 12.1739H14.8261C15.2193 11.5324 15.5241 10.8311 15.7247 10.0869H0.275879C0.47641 10.8311 0.781316 11.5324 1.17447 12.1739Z",
  fill: "#D80027"
}), React.createElement("path", {
  d: "M8 8C8 3.58175 8 3.06087 8 0C3.58175 0 0 3.58175 0 8H8Z",
  fill: "#0052B4"
}), React.createElement("path", {
  d: "M5.31968 6.84781C4.22712 6.84781 3.34143 5.9621 3.34143 4.86956C3.34143 3.77703 4.22715 2.89131 5.31968 2.89131C5.66034 2.89131 5.98087 2.97747 6.26071 3.1291C5.82171 2.69981 5.22134 2.43481 4.5588 2.43481C3.21415 2.43481 2.12402 3.52491 2.12402 4.8696C2.12402 6.21428 3.21415 7.30438 4.5588 7.30438C5.22134 7.30438 5.82171 7.03938 6.26071 6.6101C5.98087 6.76166 5.66037 6.84781 5.31968 6.84781Z",
  fill: "#FFDA44"
}), React.createElement("path", {
  d: "M5.87683 3.47827L6.22805 4.21271L7.02121 4.02946L6.66602 4.76193L7.30389 5.26777L6.50971 5.4468L6.51193 6.2609L5.87683 5.75158L5.24171 6.2609L5.24389 5.4468L4.44971 5.26777L5.08758 4.76193L4.73236 4.02946L5.52558 4.21271L5.87683 3.47827Z",
  fill: "#FFDA44"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));
const SvgMalaysia = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgMalaysia, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/malaysia.b0150d84.svg";
export { ForwardRef as ReactComponent };